import React, {useEffect, useState} from 'react';
import {Layer, Stage} from "react-konva";
import BackgroundRectangleShape from "../../../design/components/design-editor/konva-editor/background-rectangle-shape";
import useImage from "use-image";
import {
    SHOPIFY_SHOP_LOGO_HORIZONTAL_100PX,
} from "../../constants/shopify-logo-image-horizontal.constant";
import ProductImageRectangle from "../product-image/product-image-rectangle";

function downloadURI(uri, name) {
    let link = document.createElement('a');
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

const RenderFeaturedImage = ({
                                 settings,
                                 selectedImages,
                                 setSelectedImages,
                                 imageContainerClass = 'featured-image-stage-container',
                                 setImageBase64 = null,
                                 triggerImageDataPrep = false,
                             }) => {
    const [initialStep, setInitialStep] = useState(true);
    const stageRef = React.useRef(null);
    const layerRef = React.useRef(null);
    const backgroundRef = React.useRef(null);
    const [stagePos, setStagePos] = useState(null);
    const [stageScale, setStageScale] = useState(1);
    const [stageSize, setStageSize] = useState(null);
    const [showStage, setShowStage] = useState(false);

    useEffect(() => {
        if (initialStep) {
            initStage();
        }
    }, [initialStep]);

    useEffect(() => {
        if (triggerImageDataPrep) {
            prepareImageBase64Data()
        }
    }, [triggerImageDataPrep]);

    const initStage = () => {
        fitStageIntoParentContainer(settings);
        setShowStage(true);
        refreshStage();
    }

    const refreshStage = () => {
        setTimeout(() => {
            const stage = stageRef.current;
            stage.draw();

            if (setImageBase64) {
                prepareImageBase64Data();
            }
        }, 20);
    }

    const fitStageIntoParentContainer = (settings) => {
        const stage = stageRef.current;
        let container = document.querySelector('#stage-parent');
        // @ts-ignore
        let containerWidth = container?.offsetWidth - 2;
        let scale = containerWidth / settings?.width;

        setStageScale(scale);

        stage.width(settings?.width * scale);
        stage.height(settings?.height * scale);
        stage.scale({x: scale, y: scale});

        setStageSize({width: stage?.width(), height: stage?.height()});
    }

    const afterImagePropsChanged = (productImage, newAttributes) => {
        productImage.props = {...productImage.props, ...newAttributes};

        const existingSelectedImages = [...selectedImages];
        setSelectedImages(existingSelectedImages);
        refreshStage();
    }

    const handleExport = () => {
        const pixelRatio = 100 / (stageScale * 100);
        const uri = stageRef.current.toDataURL({
            pixelRatio: pixelRatio
        });

        downloadURI(uri, settings?.handle + '-featured-image' + '.jpg');
    };

    const prepareImageBase64Data = () => {
        if (setImageBase64) {
            setTimeout(() => {
                const pixelRatio = (100 / (stageScale * 100)) + 1.2;
                const uri = stageRef.current.toDataURL({
                    pixelRatio: pixelRatio,
                });

                setImageBase64(uri);
            }, 100);
        }
    }

    return (
        <>

            <div className='ml-4'>
                <div className="w-full flex justify-between items-center">
                    <div>
                        <h3 className={'text-xl font-bold text-purple-500'}>Featured Image</h3>
                    </div>
                    <div className={''}>
                        <button
                            className="button-outline-green px-3 py-2 ml-2 mr-1 my-1"
                            onClick={() => handleExport()}>
                            Download Featured Image
                        </button>
                    </div>
                </div>

                <div id="stage-parent"
                     className={`${imageContainerClass} mt-4`}>

                    <Stage width={stageSize?.width} height={stageSize?.height}
                           style={{'backgroundColor': '#FFFFFF'}}
                           className="flex justify-start border border-gray-800 shadow-lg"
                           draggable={false}
                           listening={true}
                           perfectDrawEnabled={false}
                           ref={stageRef}
                           scaleX={stageScale}
                           scaleY={stageScale}
                           x={stagePos?.x}
                           y={stagePos?.y}>

                        {showStage &&
                            <>

                                <Layer>
                                    <BackgroundRectangleShape
                                        backgroundRef={backgroundRef}
                                        background={settings?.background}
                                        stageWidth={settings?.width}
                                        stageHeight={settings?.height}/>
                                </Layer>

                                <Layer ref={layerRef}>
                                    {selectedImages?.map((productImage, productImageIndex) => (
                                        <ProductImageRectangle
                                            key={`product-image-${productImageIndex}`}
                                            onChange={(event) => {
                                                afterImagePropsChanged(productImage, event);
                                            }}
                                            productImage={productImage}/>
                                    ))}
                                </Layer>

                            </>
                        }

                    </Stage>
                </div>
            </div>

        </>
    )
}

export default RenderFeaturedImage;

